var filterBar = document.querySelectorAll('.filter-bar select');
for (let index = 0; index < filterBar.length; index++) {
	filterBar[index].addEventListener("change", function () {
		filterBar[index].closest("form").submit();
	});
}